import React from 'react';

const Help = () => {
  return (
    <div className="container" style={{ padding: '40px 20px' }}>
      <h1>Help Center</h1>
      <p>Help center coming soon...</p>
    </div>
  );
};

export default Help;
